<div class="container" lusColorTheming [primaryColor]="primaryColor">

    <!--<div class="alert alert-warning" *ngIf="(pricingProviderCode$ | async) && searchForm">
        <div>PPE: {{pricingProviderCode$ | async}} | isOB: {{isOB$ | async}} | isLP: {{isLP$ | async}}</div>
        <div>County: [{{countyFG.value}}] | State: [{{stateFG.value}}]</div>
        <div>isPurchase$: {{isPurchase$ | async}}  |  isRefi$: {{isRefi$ | async}}</div>
        <div>isVALoan: {{isVALoan}}</div>
        <div>DTI: {{debtToIncomeRatioCtrl.value}}</div>
        <div><button class="btn btn-secondary" (click)="onNewApplyNow()">Apply Now</button></div>
    </div>-->

    <!--Search Form-->
    <div>
        <ng-container *ngIf="isPublicMode">
            <div class="h2">Get your quote in seconds</div>
            <div class="Vert-10"></div>
        </ng-container>

        <lgv-loading-indicator *ngIf="isLoadingAgentInfo$ | async" [CSSClass]="'Small'"></lgv-loading-indicator>

        <div *ngIf="(pricingProviderCode$ | async) && searchForm">
            <form [formGroup]="searchForm">

                <!--Basic Fields-->
                <div class="row justify-content-between">

                    <!--1st Row-->
                    <div class="col-6 col-lg-2">
                        <mat-form-field appearance="outline" floatLabel="always" formGroupName="propertyInformation">
                            <mat-label>Zip Code</mat-label>
                            <input type="text" matInput formControlName="zipCode" maxlength="5">
                        </mat-form-field>
                    </div>

                    <div class="col-6 col-lg-2">
                        <mat-form-field appearance="outline" floatLabel="always" formGroupName="loanInformation">
                            <mat-label>Loan Purpose</mat-label>
                            <mat-select formControlName="loanPurpose" *ngIf="LoanPurposeList">
                                <mat-option *ngFor="let item of LoanPurposeList" [value]="item.ID">
                                    {{item.Display}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-6 col-lg-2">
                        <mat-form-field appearance="outline" floatLabel="always" formGroupName="propertyInformation">
                            <mat-label>Appraisal</mat-label>
                            <span matPrefix>$&nbsp;</span>
                            <input type="text" matInput matInputWithComma formControlName="appraisedValue">
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="isPurchase$ | async">
                        <div class="col-6 col-lg-2">
                            <mat-form-field appearance="outline" floatLabel="always" formGroupName="loanInformation">
                                <mat-label>Pct Down</mat-label>
                                <span matSuffix>%</span>
                                <input type="text" matInput matInputWithComma decimalPlace="3"
                                    formControlName="downPct">
                                <!--(change)="onPctDownChanged($event)" (ngModelChange)="onNgModelChange()"-->
                            </mat-form-field>
                        </div>

                        <div class="col-6 col-lg-2">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>Amount Down</mat-label>
                                <span matPrefix>$&nbsp;</span>
                                <input type="text" matInput matInputWithComma [value]="downAmt$ | async" disabled>
                            </mat-form-field>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="isRefi$ | async">
                        <div class="col-6 col-lg-2">
                            <mat-form-field appearance="outline" floatLabel="always" formGroupName="loanInformation">
                                <mat-label>Cash Out Amount</mat-label>
                                <span matPrefix>$&nbsp;</span>
                                <input type="text" matInput matInputWithComma formControlName="cashOutAmount">
                                <!--(change)="onPctDownChanged($event)" (ngModelChange)="onNgModelChange()"-->
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <div class="col-6 col-lg-2">
                        <mat-form-field appearance="outline" floatLabel="always" formGroupName="loanInformation">
                            <mat-label>Loan Amount</mat-label>
                            <span matPrefix>$&nbsp;</span>
                            <input type="text" matInput matInputWithComma formControlName="baseLoanAmount">
                        </mat-form-field>
                    </div>

                    <!--2nd row-->

                    <ng-container>
                        <div class="col-6 col-lg-3">
                            <mat-form-field appearance="outline" floatLabel="always" formGroupName="loanInformation">
                                <mat-label>Loan Type</mat-label>
                                <mat-select formControlName="loanType" *ngIf="LoanTypesList">
                                    <mat-option *ngFor="let item of LoanTypesList" [value]="item.ID">
                                        {{item.Display}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isVALoan">
                        <div class="col-6 col-lg-4">
                            <mat-form-field appearance="outline" floatLabel="always" formGroupName="borrowerInformation"
                                title="Veteran Type">
                                <mat-label>Veteran Type</mat-label>
                                <mat-select formControlName="typeOfVeteran" *ngIf="listsReady">
                                    <mat-option *ngFor="let item of TypeOfVeteranList" [value]="item.ID">
                                        {{item.Display}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <ng-container>
                            <div class="col-6 col-lg-2" formGroupName="borrowerInformation" style="margin-bottom:20px;">
                                <mat-slide-toggle formControlName="vaFirstTimeUse">1st Time VA</mat-slide-toggle>
                            </div>
                            <div class="col-6 col-lg-2" formGroupName="loanInformation" style="margin-bottom:20px;">
                                <mat-slide-toggle formControlName="exemptFromVAFundingFee">Exempt VA
                                    Fee</mat-slide-toggle>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div class="col-6 col-lg-3">
                        <mat-form-field appearance="outline" *ngIf="LoanTermList" formGroupName="loanInformation">
                            <mat-label>Loan Terms</mat-label>
                            <mat-select multiple formControlName="loanTerms">
                                <mat-option *ngFor="let item of LoanTermList" [value]="item.ID">
                                    {{item.Display}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-6 col-lg-3 col-xl-4">
                        <mat-form-field appearance="outline" *ngIf="AmortizationTypeList"
                            formGroupName="loanInformation">
                            <mat-label>Amortization Type</mat-label>
                            <mat-select multiple formControlName="amortizationTypes">
                                <mat-option *ngFor="let item of AmortizationTypeList" [value]="item.ID">
                                    {{item.Display}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!--CTA Buttons-->
                    <div class="col-6 col-lg-3 col-xl-2 text-right"
                        style="margin-top:5px; margin-left:0px; padding-left:0px;">
                        <button (click)="onReset()" class="btn btn-secondary" style="margin-right:5px;">Reset</button>
                        <button (click)="onSearchProducts(true)" class="btn btn-primary"
                            [disabled]="!searchForm.valid">Search</button>
                    </div>

                </div>

                <div class="row">
                    <div class="col-12">
                        <a (click)="onToggleAdvancedOptions()">
                            <span *ngIf="!(showAdvancedOptions$ | async)">Show</span>
                            <span *ngIf="showAdvancedOptions$ | async">Hide</span>
                            <span> Advanced Options</span>
                        </a>
                    </div>
                    <div class="col-12 Vert-20"></div>
                </div>

                <!--Advanced Options-->
                <div class="collapsible" [@collapse]="!(showAdvancedOptions$ | async)">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <mat-form-field appearance="outline" floatLabel="always"
                                formGroupName="propertyInformation">
                                <mat-label>Occupancy</mat-label>
                                <mat-select formControlName="occupancy" *ngIf="listsReady">
                                    <mat-option *ngFor="let item of OccupancyList" [value]="item.ID">
                                        {{item.Display}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-lg-6">
                            <mat-form-field appearance="outline" floatLabel="always"
                                formGroupName="propertyInformation">
                                <mat-label>Property Type</mat-label>
                                <mat-select formControlName="propertyType" *ngIf="listsReady">
                                    <mat-option *ngFor="let item of PropertyTypeList" [value]="item.ID">
                                        {{item.Display}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


                        <ng-container>
                            <div class="col-6 col-lg-2">
                                <mat-form-field appearance="outline" floatLabel="always"
                                    formGroupName="propertyInformation">
                                    <mat-label># Units</mat-label>
                                    <mat-select formControlName="numberOfUnits" *ngIf="listsReady">
                                        <mat-option *ngFor="let item of NumberOfUnitsList" [value]="item.ID">
                                            {{item.Display}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-container>

                        <ng-container>
                            <div class="col-6 col-lg-2">
                                <mat-form-field appearance="outline" floatLabel="always"
                                    formGroupName="propertyInformation">
                                    <mat-label># Stories</mat-label>
                                    <input type="text" matInput formControlName="numberOfStories">
                                </mat-form-field>
                            </div>
                        </ng-container>

                        <div class="col-6 col-lg-2">
                            <mat-form-field appearance="outline" floatLabel="always"
                                formGroupName="borrowerInformation">
                                <mat-label>Fico</mat-label>
                                <input type="text" matInput formControlName="fico">
                            </mat-form-field>
                        </div>

                        <div class="col-6 col-lg-2">
                            <mat-form-field appearance="outline" floatLabel="always"
                                formGroupName="borrowerInformation">
                                <mat-label>Monthly Debt</mat-label>
                                <span matPrefix>$&nbsp;</span>
                                <input type="text" matInput matInputWithComma formControlName="monthlyDebt">
                                <mat-error *ngIf="monthlyDebtCtrl?.errors?.comparison">
                                    Debt must be lower than income
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6 col-lg-2">
                            <mat-form-field appearance="outline" floatLabel="always"
                                formGroupName="loanInformation">
                                <mat-label>Monthly Income</mat-label>
                                <span matPrefix>$&nbsp;</span>
                                <input type="text" matInput matInputWithComma formControlName="totalMonthlyQualifyingIncome">
                                <mat-error *ngIf="monthlyIncomeCtrl?.errors?.comparison">
                                    Income must be greater than debt
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <ng-container>
                            <div class="col-6 col-lg-4">
                                <mat-form-field appearance="outline" *ngIf="ArmFixedTermList"
                                    formGroupName="loanInformation">
                                    <mat-label>Arm Fixed Term</mat-label>
                                    <mat-select multiple formControlName="armFixedTerms">
                                        <mat-option *ngFor="let item of ArmFixedTermList" [value]="item.ID">
                                            {{item.Display}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-container>

                    </div>

                    <div class="row">
                        <div class="col-6 col-lg-2" formGroupName="loanInformation" style="margin-bottom:20px;">
                            <mat-slide-toggle formControlName="interestOnly">Interest Only</mat-slide-toggle>
                        </div>
                        <div class="col-6  col-lg-2" formGroupName="borrowerInformation" style="margin-bottom:20px;">
                            <mat-slide-toggle formControlName="selfEmployed">Self Employed</mat-slide-toggle>
                        </div>
                        <div class="col-12  col-lg-2" formGroupName="borrowerInformation" style="margin-bottom:20px;">
                            <mat-slide-toggle formControlName="firstTimeHomeBuyer">First Time Buyer</mat-slide-toggle>
                        </div>
                    </div>


                </div>

            </form>
        </div>
    </div>

    <!--Product Results-->
    <!--<div *ngIf="lgvMockDataSvc.qpProducts() as Products">-->
    <div *ngIf="(productsByType$ | async) as Products">

        <div class="row">
            <div class="col-12 section-header">Mortgage loans for {{locationDisplay$ | async}}</div>
            <div class="col-12 small">The rates below are estimated rates current as of {{todaysDate | date:
                'mediumDate'}}</div>
        </div>

        <lgv-loading-indicator *ngIf="isLoadingResults$ | async" [CSSClass]="'Small'"></lgv-loading-indicator>

        <div class="Vert-20"></div>

        <!--Mobile View-->
        <div class="row d-block d-md-none mobile-view row">
            <div class="col-12" *ngFor="let p of Products">
                <mat-card>
                    <div class="section-header">{{productNameDisplay(p.keyLabel)}}</div>
                    <div class="Vert-5"></div>
                    <div class="row">
                        <div class="col-6">
                            <div class="label">P&I</div>
                            <div class="value">${{p.principalAndInterest | number : '1.0-0'}}</div>
                        </div>
                        <div class="col-6">
                            <div class="label">MI</div>
                            <div class="value">${{p.monthlyMi | number : '1.0-0'}}</div>
                        </div>
                        <div class="col-6">
                            <div class="label">Rate</div>
                            <div class="value">{{p.rate | number : '1.3-3'}}%</div>
                        </div>
                        <div class="col-6">
                            <div class="label">APR</div>
                            <div class="value">{{p.apr | number : '1.3-3'}}%</div>
                        </div>
                        <div class="col-6">
                            <div class="label">Points (Cost)</div>
                            <div class="value">
                                <span *ngIf="p.price > 100">-${{p.rebate | number:'1.0-0'}}</span>
                                <span *ngIf="p.price <= 100">${{p.discount | number:'1.0-0'}}</span>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="label">Est. Loan Costs</div>
                            <div class="value">${{p.closingCost | number:'1.0-0'}}</div>
                        </div>
                    </div>
                        <button class="btn btn-primary"
                            (click)="openStepper()">Apply Now</button>
                    <lgv-apply-now-btn [isPublicZone]="isPublicMode"
                        [rawLoanModelData]="buildLoanInfoFromProductResult(p)" [isLinkMode]="true" CSSClass="bold"
                        label="Apply "></lgv-apply-now-btn>
                </mat-card>
            </div>
            <div class="Vert-30"></div>
        </div>


        <!--Large View-->
        <div class="d-none d-md-block d-lg-block d-xl-block d-xxl-block">
            <table class='table table-striped results'>
                <thead>
                    <tr>
                        <th style="min-width:150px;">Loan Type</th>
                        <th style="min-width:50px;" class="text-right">P&I
                            <span class="infoPopup" (click)="openInfoPopup('PrincipalAndInterest');">
                                <fa-icon icon="info-circle"></fa-icon>
                            </span>
                        </th>
                        <th style="min-width:50px;" class="text-right">MI
                            <span class="infoPopup" (click)="openInfoPopup('MortgageInsurance');">
                                <fa-icon icon="info-circle"></fa-icon>
                            </span>
                        </th>
                        <th style="min-width:50px;" class="text-right">Rate</th>
                        <th style="min-width:50px;" class="text-right">APR</th>
                        <th style="min-width:50px;" class="text-right">Points</th>
                        <th style="min-width:50px;" class="text-right">Est. Loan Costs
                            <span class="infoPopup" (click)="openInfoPopup('EstimatedLoanCosts');">
                                <fa-icon icon="info-circle"></fa-icon>
                            </span>
                        </th>
                        <th style="min-width:135px;"> </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let p of Products" style="padding-bottom: 11px !important;">
                        <td class="text" style="padding-left: 10px !important;">{{productNameDisplay(p.keyLabel)}}</td>
                        <td class="text text-right">${{p.principalAndInterest | number:'1.0-0'}}</td>
                        <td class="text text-right">${{p.monthlyMi | number:'1.0-0'}}</td>
                        <td class="text text-right">{{p.rate | number : '1.3-3'}}%</td>
                        <td class="text text-right">{{p.apr | number : '1.3-3'}}%</td>
                        <td class="text text-right">
                            <span *ngIf="p.price > 100">-${{p.rebate | number:'1.0-0'}}</span>
                            <span *ngIf="p.price<=100">${{p.discount | number:'1.0-0'}}</span>
                        </td>
                        <td class="text text-right">${{p.closingCost | number:'1.0-0'}}</td>
                        <td style="vertical-align: top;">
                            <button class="btn btn-primary"
                                (click)="openStepper()">Apply Now</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="Vert-30"></div>

    </div>

    <div class="footerDisclaimer">
        <div style="text-align: center;">All content on this page is intended to be educational information for
            homeowners and homebuyers.</div>
        <div style="text-align: center;">Rates, terms and conditions are subject to change without prior notice and may
            vary based on creditworthiness, qualifications, and collateral conditions. This is not a guarantee to lend. Loan approval
            is subject to, but not limited to, property inspection waiver or completed appraisal, preliminary title
            report, minimum 2-year employment history, and the verification of satisfactory income and assets. Maximum
            loan amounts and other restrictions may apply. Credit is not guaranteed and will be contingent upon the loan
            amount and loan program. If loan does not close for any reason, out-of-pocket costs incurred by the consumer
            will not be refunded.
            <span *ngIf="agentDTO$ | async as agent">Contact <a
                    href="mailto:{{agent.agentInfo.email}}">{{agent.agentInfo.email}}</a> for current rates or more
                information.</span>
        </div>
    </div>
</div>